export const FormatMoney = (
  amount,
  decimalCount = 2,
  decimal = ".",
  thousands = ","
) => {
  if (Number(amount) == 'Infinity') return 0;
  if (Number(amount) == '-Infinity') return 0;
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    if (amount === 0) {
      return "0";
    }

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount
        ? decimal +
        Math.abs(amount - i)
          .toFixed(decimalCount)
          .slice(2)
        : "")
    );
  } catch (e) {

  }
};

// Opción 1: Función simple que divide entre 1,000
export const FormatMiles = (numero, decimales = 1) => {
  if (!numero) return "0";
  const enMiles = numero / 1000;
  return new Intl.NumberFormat("es-MX", {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales,
  }).format(enMiles);
};

// Importe sin centavos, con símbolo $ y separador de miles
export const FormatMoneyInt = (amount) => {
    if (amount === null || amount === undefined) return "$0";
    return "$" + (FormatMoney(amount, 0) ?? "0");
};

// Opción 2: Mostrar en Millones (dividir entre 1,000,000)
export const FormatMillones = (numero, decimales = 1) => {
  if (!numero) return "0";
  const enMillones = numero / 1_000_000;
  return new Intl.NumberFormat("es-MX", {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales,
  }).format(enMillones) + "M";
};

// Importe con 2 decimales y separador de miles. null/undefined/no numérico → "" (nunca "0.00").
// No modifica el valor original, solo su representación.
// Agregado: 2026-09-15 — IA (Claude)
const FORMATO_IMPORTE = new Intl.NumberFormat("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const FormatImporteNullable = (valor) => {
    if (valor === null || valor === undefined || valor === "") return "";
    const numero = Number(valor);
    return Number.isFinite(numero) ? FORMATO_IMPORTE.format(numero) : "";
};
